import { render, staticRenderFns } from "./DashboardEvent.vue?vue&type=template&id=5b89223a"
import script from "./DashboardEvent.vue?vue&type=script&lang=js"
export * from "./DashboardEvent.vue?vue&type=script&lang=js"
import style0 from "./DashboardEvent.vue?vue&type=style&index=0&id=5b89223a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports